import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-578dc81f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "colors" }
const _hoisted_2 = { class: "colors__left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "brush-map__subtitle" }, "PLUS", -1))
const _hoisted_4 = { class: "colors__left-list" }
const _hoisted_5 = { class: "colors__right" }
const _hoisted_6 = { class: "colors__right-list" }

import { ref } from 'vue'
import BrushMapListItem from './components/BrushMapListItem.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const listColors = ref([
  {
    color: '#FF517B',
    colorName: '0.4',
    type: 1,
  },
  {
    color: '#FB9B00',
    colorName: '0.45',
    type: 1,
  },
  {
    color: '#F93315',
    colorName: '0.5',
    type: 1,
  },
  {
    color: '#0f7dd8',
    colorName: '0.6',
    type: 1,
  },
  {
    color: '#F2FE5C',
    colorName: '0.7',
    type: 1,
  },
  {
    color: '#05cf40',
    colorName: '0.8',
    type: 1,
  },
  {
    color: '#590c91',
    colorName: '1.1',
    type: 1,
  },
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        _createVNode(BrushMapListItem, {
          firstPosition: 0,
          list: listColors.value,
          secondPosition: 4,
          onChangeColor: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('changeColor', $event)))
        }, null, 8, ["list"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("ul", _hoisted_6, [
        _createVNode(BrushMapListItem, {
          firstPosition: 4,
          list: listColors.value,
          secondPosition: 7,
          onChangeColor: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('changeColor', $event)))
        }, null, 8, ["list"])
      ])
    ])
  ]))
}
}

})